// @Version: 1.0.0
import { Component, Input, forwardRef } from '@angular/core';
import { COLOR, IFieldItem, POSITION } from '../field-item.model';
import { FieldItemService } from '../field-item.service';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-field-item-legend',
  templateUrl: './legend.component.html',
  providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => FieldItemLegendComponent)
      },
      {
         provide: NG_VALIDATORS,
         multi: true,
         useExisting: forwardRef(() => FieldItemLegendComponent)
      }
   ],
   standalone: false
})

export class FieldItemLegendComponent {

   public COLOR = COLOR;
   public POSITION = POSITION;
   private fieldItem_: IFieldItem = {} as IFieldItem;

   @Input() 
   get fieldItem (): IFieldItem {
      return this.fieldItem_;
   }
   set fieldItem (value: IFieldItem) {
      this.fieldItem_ = value || {};
   }

   constructor (public sFieldItem: FieldItemService) { }

   writeValue (obj: any): void {      
   }
   registerOnChange (fn: any): void {      
   }
   registerOnTouched (fn: any): void {      
   }
   setDisabledState (isDisabled: boolean | undefined): void {}

   ngOnDestroy (): void {
      this.fieldItem_= {} as IFieldItem;
   }

   validate (control: AbstractControl): ValidationErrors | null {      
      return null;
   }

   onValidationChange: any = () => {};

   registerOnValidatorChange? (fn: () => void): void {
      this.onValidationChange = fn;
   }

   private onTouched () {}
   private onChange (_: string) {}
}